import React, { Component } from 'react';
import _ from 'lodash';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import SiteIcon from 'material-ui/svg-icons/av/web';
import InvertColorsIcon from 'material-ui/svg-icons/action/invert-colors';
import InvertColorsOffIcon from 'material-ui/svg-icons/communication/invert-colors-off';


class Controls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ctaStringValue: '',
    };
  }

  handleSiteChange = (event, value) => {
    this.props.handleSiteChange(event, value);
  }

  handleCtaStringChange = (event, value) => {
    this.setState({
      ctaStringValue: value,
    });
  }

  triggerGenerated = (event) => {
    this.props.triggerGenerated(event);
    this.props.handleCtaString(event, this.state.ctaStringValue);
  }

  toggleTheme = () => {
    this.props.toggleTheme();
  }

  handleEnterKey = (target) => {
    if (target.charCode === 13) {
      this.props.triggerGenerated({});
      this.props.handleCtaString({}, this.state.ctaStringValue);
    }
  }

  render() {
    return (
      <Toolbar>
        <ToolbarGroup>
          <IconMenu
            iconButtonElement={
              <IconButton tooltip="Select an available site" tooltipPosition="bottom-right">
                <SiteIcon />
              </IconButton>
            }
            onChange={this.handleSiteChange}
            maxHeight={400}
            value={this.props.activeIndex}
          >
            {_.map(this.props.availableSites, (site, i) => {
              return <MenuItem key={i} primaryText={site.name} value={i} />;
            })}
          </IconMenu>
          <TextField
            hintText="Your CTA Text"
            onChange={this.handleCtaStringChange}
            value={this.state.ctaStringValue}
            onKeyPress={this.handleEnterKey}
          />
          <RaisedButton 
            label="Generate" 
            onClick={this.triggerGenerated}
          />
        </ToolbarGroup>
        <ToolbarGroup>
          <IconButton 
            tooltip={this.props.themeIsDark ? 'Turn On Light Mode' : 'Turn On Dark Mode'}
            tooltipPosition="bottom-left"
            onClick={this.toggleTheme}
          >
            {this.props.themeIsDark ? <InvertColorsIcon /> : <InvertColorsOffIcon />}
          </IconButton>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/Controls.js